import { createReducer, on } from '@ngrx/store';
import { clearStateRequested } from '../auth/auth.actions';
import * as patientActions from '../patient/patient.actions';
import * as patientClinicalNoteActions from './patient-clinical-note.actions';

export interface AttachmentUpload { id: string, name: string, loaded: number, total: number, createdDate: string }

export interface State {
	selectedClinicalNoteId: string;
	attachmentUploads: AttachmentUpload[];
	allAttachmentsSelected: boolean;
}

export const initialState: State = {
	selectedClinicalNoteId: '',
	attachmentUploads: [],
	allAttachmentsSelected: false
}

export const patientClinicalNoteReducer = createReducer(
	initialState,
	on(patientClinicalNoteActions.addClinicalNoteRequested, (state) => ({
		...state,
		selectedClinicalNoteId: ''
	})),
	on(patientClinicalNoteActions.addClinicalNoteCompleted, (state, { clinicalNoteId }) => ({
		...state,
		selectedClinicalNoteId: clinicalNoteId,
		allAttachmentsSelected: false
	})),
	on(patientClinicalNoteActions.clinicalNoteSelected, (state, { clinicalNoteId }) => ({
		...state,
		selectedClinicalNoteId: clinicalNoteId,
		allAttachmentsSelected: false
	})),
	on(patientClinicalNoteActions.clinicalNoteDeselected, (state) => ({
		...state,
		selectedClinicalNoteId: ''
	})),	
	on(patientClinicalNoteActions.allAttachmentsSelected, (state) => ({
		...state,
		selectedClinicalNoteId: '',
		allAttachmentsSelected: true
	})),
	on(patientClinicalNoteActions.allAttachmentsDeselected, (state) => ({
		...state,
		allAttachmentsSelected: false
	})),
	on(patientClinicalNoteActions.attachmentUploadInitiated, (state, { id, name, createdDate }) => ({
		...state,
		attachmentUploads: [...state.attachmentUploads, { id, name, loaded: 0, total: 0, createdDate }]
	})),
	on(patientClinicalNoteActions.attachmentUploadProgressed, (state, { id, loaded, total }) => ({
		...state,
		attachmentUploads: state.attachmentUploads.map(upload => upload.id === id ? { ...upload, loaded, total } : upload)
	})),
	on(patientClinicalNoteActions.attachmentUploadCompleted, (state, { id }) => ({
		...state,
		attachmentUploads: state.attachmentUploads.map(upload => upload.id === id ? { ...upload, loaded: upload.total } : upload)
	})),
	on(patientClinicalNoteActions.attachmentUploadFailed, (state, { id }) => ({
		...state,
		attachmentUploads: state.attachmentUploads.filter(upload => upload.id !== id)
	})),
	on(patientClinicalNoteActions.attachmentUploadsRemoved, (state, { ids }) => ({
		...state,
		attachmentUploads: state.attachmentUploads.filter(upload => !ids.includes(upload.id))
	})),
	on(patientClinicalNoteActions.removeAttachmentCompleted, (state, { id }) => ({
		...state,
		attachmentUploads: state.attachmentUploads.filter(upload => upload.id !== id)
	})),
	on(patientActions.patientDeselected, () => initialState),
	on(clearStateRequested, () => initialState)
);
